import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_MAN_CHARGE_HDR_COL_DEF, transferRowData } from "presentation/constant/ManualCharge/ManChargeHdrColumnDefinition";
import { useManualChargeHeaderMaintenanceVM } from "presentation/hook/ManualCharge/useManualChargeHeaderMaintenanceVM";
import { useManualChargeHeaderMaintenanceTracked } from "presentation/store/ManualCharge/ManualChargeHeaderMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import ManualChargeHeaderPrintModal from "../ManualChargeHeaderPrintModal";


const ManualChargeHeaderTablePanel: React.FC = () => {
    const [manualChargeHeaderState] = useManualChargeHeaderMaintenanceTracked();
    const manualChargeHeaderVM = useManualChargeHeaderMaintenanceVM();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    let gridRef: any = useRef();
    /*const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(manualChargeHeaderState.isSearchLoading || (!manualChargeHeaderState.isSearchLoading &&
            manualChargeHeaderState.manualChargeHeaders && manualChargeHeaderState.manualChargeHeaders.length) ? false : true);

        if (gridRef.current?.gridRef.current && !manualChargeHeaderState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [manualChargeHeaderState.isSearchLoading, manualChargeHeaderState.manualChargeHeaders]);*/

    useEffect(() => {
        if (!onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();
    }, [onTableSelectionClicked])

    useEffect(() => {
        //const columnDefs = (INITIAL_MAN_CHARGE_HDR_COL_DEF?.slice());

        if (!manualChargeHeaderState.selectedManualChargeHeaderRows ||
            manualChargeHeaderState.selectedManualChargeHeaderRows.length <= 0) {
            //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
            if (!onTableSelectionClicked) {
                gridRef.current?.gridRef.current.api?.deselectAll();
            }
        }
    })

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        manualChargeHeaderVM.updateSelectedManualChargeHeaders(selectedRows);
    }, [manualChargeHeaderVM])

    const memoManualChargeHeaderTable = useMemo(() => {
        return (
            <>
                <NbisTable
                    id='manual-charge-header-table'
                    isNewColumnSetting={true}
                    columns={INITIAL_MAN_CHARGE_HDR_COL_DEF?.slice()}
                    // headerLabel={'Manual Charge'}
                    data={transferRowData(manualChargeHeaderState.manualChargeHeaders ?? [])}
                    showPaginator={false}
                    editable={false}
                    showHeaderIcons={true}
                    showAddIcon={false}
                    showDeleteButton={false}
                    showReloadIcon={false}
                    isScrollHighlighted={true}
                    selectionMode={false}
                    rowSelection={"multiple"}
                    isRowHighligted={true}
                    handleSelectionChanged={handleSelectionChange}
                    onRowDoubleClick={(e: any) => { manualChargeHeaderVM.onDetail(e.data) }}
                    gridHeight="customHeight"
                    customHeight="calc(100vh - 125px)"
                    ref={gridRef}
                    isLoading={manualChargeHeaderState.isSearchLoading}
                //showDefaultOverlayNoRowsTemplate={showOverlay}
                />
            </>
        );
    }, [handleSelectionChange, manualChargeHeaderState.isSearchLoading, manualChargeHeaderState.manualChargeHeaders, manualChargeHeaderVM])

    return <><TableWrapper>{manualChargeHeaderState.manualChargeHeaders === undefined || manualChargeHeaderState.manualChargeHeaders === null
        || memoManualChargeHeaderTable}</TableWrapper>
        {manualChargeHeaderState.isShowPrintModal && <ManualChargeHeaderPrintModal />}
    </>;
}

export default memo(ManualChargeHeaderTablePanel);
